import React, { Component } from "react";
import { Link } from 'react-router-dom'
import DataTable from "react-data-table-component";
import Constant from "../../Constant";

export default class Batches extends Component {
  state = {
    data: [],
    columns: [
      {
        name: "ID",
        selector: "id",
        sortable: true
      },
      {
        name: "User",
        selector: "user",
        sortable: true
      },
      {
        name: "Email",
        selector: "email",
        sortable: true,
        right: true
      },
      {
        name: "User Type",
        selector: "type",
        sortable: true,
        right: true
      },
      {
        name: "Registration",
        selector: "registration",
        sortable: true,
        right: true
      },
      {
        name: "Last Login",
        selector: "lastLogin",
        sortable: true,
        right: true
      },
      {
        name: "Options",
        selector: "year",
        sortable: true,
        right: true,
        cell: row => (
          <div className="d-flex">
            <div className="btn btn-light shadow-sm mx-1">
              <i class="fas fa-pencil-alt text-primary"></i>
            </div>
            <div className="btn btn-light shadow-sm mx-1">
              <i class="fas fa-times text-danger"></i>
            </div>
          </div>
        )
      }
    ]
  }

  componentDidMount() {
    this.getBatchList();
  }
  getBatchList = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    // urlencoded.append("courseId", this.props.match.params.course_id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/batch/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data[0].users;
        var courseName = result.data[0].name;
        for (let i = 0; i < data.length; i++) {
          console.log(data[i]);
          var str = data[i].createdAt;
          var date = new Date(str);
          data[i].fullName = data[i].firstName + " " + data[i].lastName;
          console.log(data[i]);
          data[i].createdAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
            }-${date.getUTCFullYear()}`;
          data[i].updatedAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
            }-${date.getUTCFullYear()}`;
        }
        this.setState({ data: data, courseName: courseName, loading: false });
      })
      .catch((error) => console.log("error", error));
  };
  render() {
    return (
      <div className="pt-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /<b> Batches</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                <Link to="/admin/add-batch" className="btn btn-dark float-right">Add Batch</Link>
              </div>
            </div>
          </div>

          <div className="users-container p-2">
            <DataTable
              noHeader={true}
              columns={this.state.columns}
              data={this.state.data}
              theme="solarized"
            />
          </div>
        </div>
      </div>
    );
  }
}
